// extracted by mini-css-extract-plugin
export default {"wrapManButton":"settlementView_wrapManButton__AjKDB","tableLabel":"settlementView_tableLabel__JahH5"};